/* Imagine Creation — หน้าไอเดียร้าน + หน้าโปรเจกต์
   แท็บประเภท/ตัวกรอง · ดูเพิ่ม · popup รายละเอียด (+ลิงก์ #idea-handle) · ไอเดียเด่น · ลากเทียบภาพ · lightbox */
(function () {
  if (window.__icInsp) return;
  window.__icInsp = true;

  var ICON_PREV = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10 3L5 8l5 5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICON_NEXT = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6 3l5 5-5 5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICON_X = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 2l10 10M12 2L2 12" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';

  function $(sel, el) { return (el || document).querySelector(sel); }
  function $$(sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); }
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── เลื่อนภาพใน track แบบ scroll-snap ── */
  function slideIndex(track) { return Math.round(track.scrollLeft / (track.clientWidth || 1)); }
  function slideCount(track) { return track.children.length; }
  function goSlide(track, i) {
    var n = slideCount(track);
    if (!n) return;
    i = (i + n) % n;
    track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
  }
  function watchCounter(track, out, fmt) {
    if (!out) return;
    var raf = 0;
    var upd = function () { raf = 0; out.textContent = fmt(slideIndex(track) + 1, slideCount(track)); };
    track.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(upd); }, { passive: true });
    upd();
  }
  function lock(on) { document.documentElement.style.overflow = on ? 'hidden' : ''; }
  function clearHash() {
    if (/^#idea-/.test(location.hash) && history.replaceState) history.replaceState(null, '', location.pathname + location.search);
  }

  /* ── แกลเลอรีไอเดีย ── */
  function initHub(root) {
    if (root.__ready) return;
    root.__ready = true;
    var cards = $$('.hub-card', root);
    var tabs = $$('[data-hub-tabs] .hub-tab', root);
    var sels = $$('select[data-f]', root);
    var step = parseInt(root.dataset.step, 10) || 8;
    var limit = step;
    var shownEl = $('[data-hub-shown]', root);
    var emptyEl = $('[data-hub-empty]', root);
    var moreRow = $('[data-hub-more-row]', root);
    var resetBtns = $$('[data-hub-reset]', root);
    var state = { type: '', style: '', size: '', budget: '' };
    var defaultType = '';

    var pressed = tabs.filter(function (t) { return t.getAttribute('aria-pressed') === 'true'; })[0];
    if (pressed) defaultType = state.type = pressed.dataset.match || '';
    var q = new URLSearchParams(location.search).get('type');
    if (q) {
      var qt = tabs.filter(function (t) { return (t.dataset.match || '') === q && !t.dataset.url; })[0];
      if (qt) { state.type = q; setTab(qt); }
    }

    function setTab(tab) { tabs.forEach(function (t) { t.setAttribute('aria-pressed', String(t === tab)); }); }
    function match(c) {
      return (!state.type || c.dataset.type === state.type) &&
        (!state.style || (c.dataset.style || '').indexOf('|' + state.style + '|') > -1) &&
        (!state.size || c.dataset.size === state.size) &&
        (!state.budget || c.dataset.budget === state.budget);
    }
    function apply() {
      var m = 0;
      cards.forEach(function (c) {
        var ok = match(c);
        if (ok) m++;
        c.hidden = !ok || m > limit;
      });
      if (shownEl) shownEl.textContent = m;
      if (emptyEl) emptyEl.classList.toggle('is-on', m === 0);
      if (moreRow) moreRow.hidden = m <= limit;
      var dirty = state.style || state.size || state.budget || state.type !== defaultType;
      resetBtns.forEach(function (b) { if (b.closest('.hub-bar')) b.hidden = !dirty; });
    }
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        var url = t.dataset.url;
        if (url && url.split('?')[0] !== location.pathname) { location.href = url; return; }
        state.type = t.dataset.match || '';
        setTab(t);
        limit = step;
        apply();
      });
    });
    sels.forEach(function (s) {
      s.addEventListener('change', function () {
        state[s.dataset.f] = s.value;
        s.classList.toggle('is-set', !!s.value);
        limit = step;
        apply();
      });
    });
    resetBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        state.style = state.size = state.budget = '';
        state.type = defaultType;
        sels.forEach(function (s) { s.value = ''; s.classList.remove('is-set'); });
        var dt = tabs.filter(function (t) { return (t.dataset.match || '') === defaultType && !t.dataset.url; })[0] || tabs[0];
        if (dt) setTab(dt);
        limit = step;
        apply();
      });
    });
    var more = $('[data-hub-more]', root);
    if (more) more.addEventListener('click', function () { limit += step; apply(); });

    /* กรองสไตล์จากคลังสไตล์ ("ดู N ไอเดียสไตล์นี้") หรือ ?style= */
    function setStyle(v) {
      var s = sels.filter(function (x) { return x.dataset.f === 'style'; })[0];
      if (!s || !$$('option', s).some(function (o) { return o.value === v; })) return false;
      s.value = v;
      s.classList.add('is-set');
      state.style = v;
      var any = cards.some(function (c) { return (c.dataset.style || '').indexOf('|' + v + '|') > -1 && (!state.type || c.dataset.type === state.type); });
      if (!any) {
        state.type = '';
        var all = tabs.filter(function (t) { return !t.dataset.match && !t.dataset.url; })[0];
        if (all) setTab(all);
      }
      limit = step;
      apply();
      return true;
    }
    document.addEventListener('ic:style', function (e) { setStyle(e.detail); });
    var qs = new URLSearchParams(location.search).get('style');
    if (qs) setStyle(qs);

    /* popup */
    var dlg = $('[data-insp-dlg]', root);
    var opener = null;
    function open(card, from) {
      var tpl = $('template[data-hub-tpl]', card);
      if (!dlg || !tpl) return;
      var frag = tpl.content.cloneNode(true);
      var media = $('[data-dlg-media]', dlg);
      var body = $('[data-dlg-body]', dlg);
      media.innerHTML = '';
      body.innerHTML = '';
      var track = $('[data-dlg-track]', frag);
      var info = $('[data-dlg-info]', frag);
      if (track) media.appendChild(track);
      if (info) { while (info.firstChild) body.appendChild(info.firstChild); }
      opener = from || null;
      var n = track ? slideCount(track) : 0;
      $$('[data-dlg-step]', dlg).forEach(function (b) { b.hidden = n < 2; });
      var ctr = $('[data-dlg-ctr]', dlg);
      ctr.hidden = n < 2;
      if (!dlg.open) { if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', ''); }
      lock(true);
      var x = $('.insp-dlg__x', dlg);
      if (x) x.focus();
      if (track) {
        track.scrollLeft = 0;
        watchCounter(track, ctr, function (i, t) {
          var s = track.children[i - 1];
          return s && s.hasAttribute('data-plan') ? 'ผังร้าน' : i + ' / ' + t;
        });
      }
      body.scrollTop = 0;
      document.dispatchEvent(new CustomEvent('ic:board-sync'));
      if (history.replaceState) history.replaceState(null, '', '#' + card.id);
    }
    function close() { if (dlg && dlg.open) { if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open'); } }
    cards.forEach(function (c) {
      var hit = $('[data-hub-open]', c);
      if (hit) hit.addEventListener('click', function () { open(c, hit); });
    });
    if (dlg) {
      dlg.addEventListener('close', function () {
        lock(false);
        $('[data-dlg-media]', dlg).innerHTML = '';
        $('[data-dlg-body]', dlg).innerHTML = '';
        clearHash();
        if (opener && opener.focus) opener.focus();
      });
      dlg.addEventListener('click', function (e) {
        if (e.target === dlg) { close(); return; }
        var st = e.target.closest('[data-dlg-step]');
        if (st) { var t = $('[data-dlg-track]', dlg); if (t) goSlide(t, slideIndex(t) + Number(st.dataset.dlgStep)); return; }
        if (e.target.closest('[data-insp-close]')) close();
      });
      dlg.addEventListener('keydown', function (e) {
        var t = $('[data-dlg-track]', dlg);
        if (!t) return;
        if (e.key === 'ArrowRight') { e.preventDefault(); goSlide(t, slideIndex(t) + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goSlide(t, slideIndex(t) - 1); }
      });
    }
    function fromHash() {
      var h = location.hash;
      if (!/^#idea-/.test(h)) return;
      var id = h.slice(1);
      try { id = decodeURIComponent(id); } catch (err) {}
      var card = document.getElementById(id);
      if (card && card.closest('[data-hub]') === root) open(card, null);
    }
    window.addEventListener('hashchange', fromHash);
    apply();
    fromHash();
  }

  /* ── ไอเดียเด่น ── */
  function initFeat(root) {
    if (root.__ready) return;
    root.__ready = true;
    var slides = $$('[data-feat]', root);
    var ths = $$('[data-feat-go]', root);
    ths.forEach(function (b) {
      b.addEventListener('click', function () {
        var i = b.dataset.featGo;
        slides.forEach(function (s) { s.hidden = s.dataset.feat !== i; });
        ths.forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      });
    });
  }

  /* ── ลากเทียบภาพ (3D ↔ ภาพร่าง / 3D ↔ ร้านจริง) ── */
  function initCompare(box) {
    if (box.__ready) return;
    box.__ready = true;
    $$('.cmp', box).forEach(function (c) {
      var range = $('.cmp__range', c);
      var set = function (v) { v = Math.max(0, Math.min(100, v)); c.style.setProperty('--pos', v + '%'); range.value = v; };
      range.addEventListener('input', function () { set(Number(range.value)); });
      var down = false;
      var fromX = function (x) { var r = c.getBoundingClientRect(); return (x - r.left) / r.width * 100; };
      c.addEventListener('pointerdown', function (e) {
        down = true;
        try { c.setPointerCapture(e.pointerId); } catch (err) {}
        set(fromX(e.clientX));
      });
      c.addEventListener('pointermove', function (e) { if (down) set(fromX(e.clientX)); });
      ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (t) { c.addEventListener(t, function () { down = false; }); });
    });
    $$('[data-cmp-go]', box).forEach(function (b) {
      b.addEventListener('click', function () {
        var i = b.dataset.cmpGo;
        $$('.cmp', box).forEach(function (c) { c.hidden = c.dataset.cmpPair !== i; });
        $$('[data-cmp-go]', box).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      });
    });
  }

  /* ── lightbox แกลเลอรีหน้าโปรเจกต์ ── */
  var lb = null;
  function lightbox() {
    if (lb) return lb;
    lb = document.createElement('dialog');
    lb.className = 'insp-dlg insp-dlg--lb';
    lb.setAttribute('aria-label', 'ภาพผลงาน');
    lb.innerHTML = '<div class="insp-dlg__media"><div class="insp-dlg__track" data-dlg-track></div>' +
      '<span class="insp-dlg__ctr" data-dlg-ctr></span>' +
      '<button type="button" class="insp-dlg__nav insp-dlg__nav--prev" data-step="-1" aria-label="ภาพก่อนหน้า">' + ICON_PREV + '</button>' +
      '<button type="button" class="insp-dlg__nav insp-dlg__nav--next" data-step="1" aria-label="ภาพถัดไป">' + ICON_NEXT + '</button></div>' +
      '<button type="button" class="insp-dlg__x" data-x aria-label="ปิด">' + ICON_X + '</button>';
    document.body.appendChild(lb);
    var track = $('[data-dlg-track]', lb);
    watchCounter(track, $('[data-dlg-ctr]', lb), function (i, n) { return i + ' / ' + n; });
    lb.addEventListener('click', function (e) {
      if (e.target === lb || e.target.closest('[data-x]')) { lb.close(); return; }
      var s = e.target.closest('[data-step]');
      if (s) goSlide(track, slideIndex(track) + Number(s.dataset.step));
    });
    lb.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goSlide(track, slideIndex(track) + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goSlide(track, slideIndex(track) - 1); }
    });
    lb.addEventListener('close', function () { lock(false); track.innerHTML = ''; });
    return lb;
  }
  document.addEventListener('click', function (e) {
    var item = e.target.closest('[data-lb-src]');
    if (!item) return;
    var group = item.closest('[data-lb-group]') || item.parentNode;
    var items = $$('[data-lb-src]', group);
    var d = lightbox();
    var track = $('[data-dlg-track]', d);
    track.innerHTML = '';
    items.forEach(function (it) {
      var f = document.createElement('figure');
      f.className = 'insp-dlg__slide';
      var img = document.createElement('img');
      img.src = it.dataset.lbSrc;
      img.alt = it.dataset.lbAlt || '';
      img.loading = 'lazy';
      f.appendChild(img);
      if (it.dataset.lbCap) {
        var cap = document.createElement('figcaption');
        cap.className = 'insp-dlg__cap';
        cap.textContent = it.dataset.lbCap;
        f.appendChild(cap);
      }
      track.appendChild(f);
    });
    $$('[data-step]', d).forEach(function (b) { b.hidden = items.length < 2; });
    d.showModal();
    lock(true);
    var x = $('[data-x]', d);
    if (x) x.focus();
    track.scrollLeft = items.indexOf(item) * track.clientWidth;
  });

  /* ── เลื่อนไปที่ element (เผื่อแถบเมนูด้านบน) ── */
  function scrollToEl(el, off) {
    if (!el) return;
    var y = el.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop) - (off == null ? 84 : off);
    window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
  }

  /* ── คลังสไตล์: แท็บกลุ่ม · ตัวช่วยหาสไตล์ ── */
  var MOOD_TH = { calm: 'สงบ เรียบง่าย', warm: 'อบอุ่น', nature: 'ใกล้ธรรมชาติ', raw: 'เท่ ดิบ', story: 'มีเรื่องเล่า', fun: 'สนุก สีสด', lux: 'หรู พรีเมียม' };
  var SUIT_TH = { cafe: 'ร้านกาแฟ', shop: 'ร้านค้า', food: 'ร้านอาหาร' };
  function words(s) { return ' ' + (s || '').replace(/[,|]/g, ' ').replace(/\s+/g, ' ').trim() + ' '; }
  function has(list, v) { return words(list).indexOf(' ' + v + ' ') > -1; }

  function initAtlas(root) {
    if (root.__ready) return;
    root.__ready = true;
    var cards = $$('.sty', root);
    var tabs = $$('[data-atlas-tabs] .hub-tab[data-fam]', root);

    var tabBox = $('[data-atlas-tabs]', root);
    var pill = null;
    /* แสดงก่อนกลุ่มละ N สไตล์ ที่เหลืออยู่หลังปุ่ม "ดูครบ" */
    var per = parseInt(root.dataset.per, 10) || 0;
    var moreRow = $('[data-atlas-more-row]', root);
    var expanded = !per || !moreRow;
    var seen = {};
    cards.forEach(function (c) { var f = c.dataset.family; seen[f] = (seen[f] || 0) + 1; c.__fi = seen[f] - 1; });
    function clearMatch() { if (pill) { pill.remove(); pill = null; } }
    function setFam(f) {
      clearMatch();
      var tab = tabs.filter(function (t) { return t.dataset.fam === f; })[0];
      if (!tab) { f = ''; tab = tabs[0]; }
      tabs.forEach(function (t) { t.setAttribute('aria-pressed', String(t === tab)); });
      cards.forEach(function (c) { c.hidden = f ? c.dataset.family !== f : (!expanded && c.__fi >= per); });
      if (moreRow) moreRow.hidden = expanded || !!f;
    }
    function expand() { expanded = true; setFam(''); }
    root.__expand = expand;
    if (moreRow) $('[data-atlas-more]', moreRow).addEventListener('click', expand);
    setFam('');
    /* แสดงเฉพาะสไตล์ที่เข้ากับคำตอบของตัวช่วย */
    function showOnly(list) {
      clearMatch();
      tabs.forEach(function (t) { t.setAttribute('aria-pressed', 'false'); });
      cards.forEach(function (c) { c.hidden = list.indexOf(c) < 0; });
      if (moreRow) moreRow.hidden = true;
      pill = document.createElement('span');
      pill.className = 'hub-atlas__match';
      pill.textContent = 'สไตล์ที่เข้ากับคำตอบ ' + list.length + ' สไตล์';
      var x = document.createElement('button');
      x.type = 'button';
      x.setAttribute('aria-label', 'แสดงทุกสไตล์');
      x.textContent = '×';
      x.addEventListener('click', function () { setFam(''); });
      pill.appendChild(x);
      if (tabBox) { tabBox.insertBefore(pill, tabBox.firstChild); scrollToEl(tabBox, 90); }
    }
    root.__setFam = setFam;
    tabs.forEach(function (t) { t.addEventListener('click', function () { setFam(t.dataset.fam); }); });

    /* ตัวช่วยหาสไตล์ */
    var finder = $('[data-finder]', root);
    if (!finder) return;
    var out = $('[data-finder-out]', finder);
    var hint = $('[data-finder-hint]', finder);
    var sum = $('[data-finder-sum]', finder);
    var allBtn = $('[data-finder-all]', finder);
    var fits = [];
    if (allBtn) allBtn.addEventListener('click', function () { if (fits.length) showOnly(fits); });
    var fixedSuit = finder.dataset.suit || '';
    var pick = { suit: fixedSuit, mood: '', tier: '' };
    $$('[data-q]', finder).forEach(function (row) {
      var k = row.dataset.q;
      $$('.hub-chip', row).forEach(function (chip) {
        chip.addEventListener('click', function () {
          var on = chip.getAttribute('aria-pressed') !== 'true';
          $$('.hub-chip', row).forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
          chip.setAttribute('aria-pressed', String(on));
          pick[k] = on ? chip.dataset.v : '';
          suggest();
        });
      });
    });

    function thumb(card) {
      var box = document.createElement('span');
      box.className = 'hub-finder__th';
      var img = $('.sty__media > img', card);
      if (img) {
        var i = document.createElement('img');
        i.src = img.currentSrc || img.src;
        i.alt = '';
        i.loading = 'lazy';
        box.appendChild(i);
      } else {
        var mood = $('.ic-mood', card);
        if (mood) box.appendChild(mood.cloneNode(true));
      }
      return box;
    }
    function suggest() {
      out.innerHTML = '';
      var any = pick.mood || pick.tier || (pick.suit && !fixedSuit);
      if (hint) hint.hidden = !!any;
      if (sum) sum.hidden = !any;
      if (allBtn) allBtn.hidden = true;
      fits = [];
      if (!any) return;
      var want = Number(pick.tier) || 0;
      var ranked = [];
      cards.forEach(function (c, i) {
        if (pick.suit && !has(c.dataset.suits, pick.suit)) return;
        var s = 0;
        var moodHit = pick.mood && has(c.dataset.moods, pick.mood);
        if (moodHit) s += 4;
        var t = Number(c.dataset.tier) || 2;
        if (want) s += t === want ? 2 : (t < want ? 1 : -3);
        ranked.push({ c: c, s: s, i: i, m: moodHit, t: t });
      });
      ranked.sort(function (a, b) { return b.s - a.s || a.i - b.i; });
      fits = ranked.filter(function (r) { return (!pick.mood || r.m) && (!want || r.t <= want); }).map(function (r) { return r.c; });
      var top = ranked.slice(0, 3);
      if (sum) sum.innerHTML = fits.length ? 'ตรงกับคำตอบ <b>' + fits.length + '</b> สไตล์ · ' + Math.min(3, top.length) + ' อันดับแรก' : 'ยังไม่มีสไตล์ที่ตรงทุกข้อ · ใกล้เคียงที่สุด';
      if (allBtn && fits.length > 3) { allBtn.hidden = false; allBtn.textContent = 'ดูทั้ง ' + fits.length + ' สไตล์ที่เข้ากันในคลัง ↓'; }
      if (!top.length) {
        var li = document.createElement('li');
        li.className = 'hub-finder__hint';
        li.textContent = 'ยังไม่มีสไตล์ที่ตรงทุกข้อ ลองเปลี่ยนคำตอบดูครับ';
        out.appendChild(li);
        return;
      }
      top.forEach(function (r) {
        var c = r.c;
        var why = [];
        if (pick.suit && !fixedSuit) why.push('เหมาะกับ' + SUIT_TH[pick.suit]);
        if (r.m) why.push('ฟีล' + MOOD_TH[pick.mood]);
        why.push('งบ ' + new Array(r.t + 1).join('฿'));
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + c.id;
        a.setAttribute('data-style-jump', '');
        a.appendChild(thumb(c));
        var txt = document.createElement('span');
        var nm = document.createElement('span');
        nm.className = 'hub-finder__nm';
        nm.textContent = c.dataset.en;
        var sm = document.createElement('small');
        sm.textContent = c.dataset.th;
        nm.appendChild(sm);
        var w = document.createElement('span');
        w.className = 'hub-finder__why';
        w.textContent = why.join(' · ');
        txt.appendChild(nm);
        txt.appendChild(w);
        a.appendChild(txt);
        li.appendChild(a);
        out.appendChild(li);
      });
    }
  }

  /* เปิดสไตล์ในคลัง (จากการ์ดเทรนด์ / ผลตัวช่วย / บอร์ด) */
  function jumpToStyle(id) {
    var card = document.getElementById(id);
    if (!card) return false;
    var atlas = card.closest('[data-atlas]');
    if (card.hidden && atlas && atlas.__setFam) atlas.__setFam('');
    if (card.hidden && atlas && atlas.__expand) atlas.__expand();
    scrollToEl(card, 110);
    card.classList.remove('is-flash');
    void card.offsetWidth;
    card.classList.add('is-flash');
    return true;
  }

  document.addEventListener('click', function (e) {
    /* กลุ่มสไตล์ใน hero → เปิดแท็บกลุ่มนั้นในคลัง */
    var fam = e.target.closest('[data-fam-go]');
    if (fam) {
      var atlas = $('[data-atlas]');
      if (atlas && atlas.__setFam) {
        e.preventDefault();
        atlas.__setFam(fam.dataset.famGo);
        scrollToEl(atlas, 70);
      }
      return;
    }
    var jump = e.target.closest('[data-style-jump]');
    if (jump) {
      var id = (jump.getAttribute('href') || '').replace(/^#/, '');
      try { id = decodeURIComponent(id); } catch (err) {}
      if (jumpToStyle(id)) e.preventDefault();
      return;
    }
    /* "ดู N ไอเดียสไตล์นี้" → กรองแกลเลอรีตามสไตล์ */
    var go = e.target.closest('[data-style-go]');
    if (go) {
      var hub = $('[data-hub]');
      if (!hub) return;
      e.preventDefault();
      document.dispatchEvent(new CustomEvent('ic:style', { detail: go.dataset.styleGo }));
      scrollToEl(hub, 64);
    }
  });

  /* ── ผังตัวอย่าง: ตัวสลับผังอยู่ใน section ic-insp-layouts เอง (root.__laySel) ── */
  function jumpToLayout(h) {
    var p = document.getElementById('layout-' + h);
    if (!p) return false;
    var root = p.closest('[data-lay]');
    if (root && root.__laySel) return root.__laySel(p, true);
    scrollToEl(p, 72);
    return true;
  }
  /* ── บอร์ดไอเดีย (เก็บสไตล์ + ไอเดียที่ชอบ ไว้ในเครื่องผู้ใช้) ── */
  var BOARD_KEY = 'ic_idea_board';
  var mem = [];
  function readBoard() {
    try { var v = JSON.parse(localStorage.getItem(BOARD_KEY) || '[]'); return Array.isArray(v) ? v : []; } catch (err) { return mem.slice(); }
  }
  function writeBoard(list) {
    mem = list.slice();
    try { localStorage.setItem(BOARD_KEY, JSON.stringify(list)); } catch (err) {}
  }
  function keyOf(btn) { return (btn.dataset.kind || 'idea') + ':' + btn.dataset.save; }
  var KIND = {
    style: { pre: 'style-', th: 'สไตล์' },
    idea: { pre: 'idea-', th: 'ไอเดีย' },
    layout: { pre: 'layout-', th: 'ผังตัวอย่าง' }
  };
  function kindOf(it) { return KIND[it.k] || KIND.idea; }
  function itemUrl(it) {
    return location.origin + location.pathname + '#' + kindOf(it).pre + it.h;
  }
  /* งบโดยประมาณจากบอร์ด: พื้นที่ของผังที่เก็บ × ระดับงบของสไตล์ที่เก็บ (ตัวเลขจาก Theme settings ผ่าน data-px-* ของบอร์ด) */
  function pxFull(n) { return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function pxMil(n) { return String(Math.round(n / 10000) / 100); }
  function boardBudget(list) {
    var dlg = $('[data-board]');
    if (!dlg || !dlg.getAttribute('data-px-t1')) return null;
    var tiers = [], areas = [];
    list.forEach(function (it) {
      var src = $('[data-save="' + String(it.h).replace(/"/g, '') + '"][data-kind="' + it.k + '"]');
      if (it.k === 'style') {
        var t = +it.t || (src ? +src.getAttribute('data-tier') : 0);
        if (t >= 1 && t <= 3) tiers.push(t);
      } else if (it.k === 'layout') {
        var a = +it.a || (src ? +src.getAttribute('data-area') : 0);
        if (a > 0) areas.push(a);
      }
    });
    if (!tiers.length && !areas.length) return null;
    var lo = tiers.length ? Math.min.apply(null, tiers) : 2, hi = tiers.length ? Math.max.apply(null, tiers) : 2;
    var r1 = (dlg.getAttribute('data-px-t' + lo) || '0-0').split('-'), r2 = (dlg.getAttribute('data-px-t' + hi) || '0-0').split('-');
    var mn = +r1[0] || 0, mx = +r2[1] || 0;
    var dots = function (t) { return '฿฿฿'.slice(0, t); };
    var tt = lo === hi ? dots(lo) : dots(lo) + '–' + dots(hi);
    var note = dlg.getAttribute('data-px-note') || '';
    if (!areas.length) return { v: pxFull(mn) + '–' + pxFull(mx) + ' บ./ตร.ม.', n: 'สไตล์ระดับ ' + tt + ' · เก็บผังตัวอย่างไว้ด้วย จะคำนวณเป็นงบรวมให้', note: note };
    var aMin = Math.min.apply(null, areas), aMax = Math.max.apply(null, areas);
    var v1 = aMin * mn, v2 = aMax * mx;
    return {
      v: v2 >= 1e6 ? pxMil(v1) + '–' + pxMil(v2) + ' ล้านบาท' : pxFull(v1) + '–' + pxFull(v2) + ' บาท',
      n: 'ผัง ' + (aMin === aMax ? aMin : aMin + '–' + aMax) + ' ตร.ม. × ' + (tiers.length ? 'สไตล์ระดับ ' + tt : 'ระดับ ฿฿ (ยังไม่ได้เก็บสไตล์)'),
      note: note
    };
  }
  function boardText(list) {
    var lines = ['สไตล์และไอเดียที่ชอบ:'];
    list.forEach(function (it) { lines.push('• ' + kindOf(it).th + ' ' + it.name + ' — ' + itemUrl(it)); });
    var bb = boardBudget(list);
    if (bb) lines.push('งบโดยประมาณ: ' + bb.v + ' (' + bb.n + ')');
    lines.push('', 'ประเภทร้าน: ', 'ขนาดพื้นที่ (กว้าง × ลึก): ', 'ตึกแถว / ในห้าง / อาคารเดี่ยว: ', 'งบประมาณโดยประมาณ: ');
    return lines.join('\n');
  }

  var boardApi = null;
  function initBoard() {
    var dlg = $('[data-board]');
    if (!dlg) { boardApi = null; return; }
    if (dlg.__ready) { $$('.hub-save[hidden], .hub-lay__save[hidden]').forEach(function (b) { b.hidden = false; }); boardApi.sync(false); return; }
    dlg.__ready = true;
    var fab = $('[data-board-open]');
    var listEl = $('[data-board-list]', dlg);
    var copyBtn = $('[data-board-copy]', dlg);
    var copyLbl = copyBtn ? copyBtn.textContent : '';

    $$('.hub-save[hidden], .hub-lay__save[hidden]').forEach(function (b) { b.hidden = false; });

    function sync(bump) {
      var list = readBoard();
      var keys = list.map(function (it) { return it.k + ':' + it.h; });
      $$('[data-save]').forEach(function (b) {
        var on = keys.indexOf(keyOf(b)) > -1;
        b.setAttribute('aria-pressed', String(on));
        var l = b.dataset.lblOn ? $('[data-save-lbl]', b) : null;
        if (l) l.textContent = on ? b.dataset.lblOn : b.dataset.lblOff;
      });
      $$('[data-save-proxy]').forEach(function (b) {
        var on = keys.indexOf('idea:' + b.dataset.saveProxy) > -1;
        b.setAttribute('aria-pressed', String(on));
        var l = $('[data-save-lbl]', b);
        if (l) l.textContent = on ? 'เก็บในบอร์ดแล้ว' : 'เก็บไว้ในบอร์ด';
      });
      $$('[data-board-count]').forEach(function (n) { n.textContent = list.length; });
      if (fab) {
        fab.hidden = list.length === 0;
        if (bump && !reduce) { fab.classList.remove('is-bump'); void fab.offsetWidth; fab.classList.add('is-bump'); }
      }
      if (dlg.open) render(list);
    }
    function renderSum(list) {
      var el = $('[data-board-sum]', dlg);
      if (!el) return;
      var bb = list.length ? boardBudget(list) : null;
      el.hidden = !bb;
      el.innerHTML = '';
      if (!bb) return;
      var sm = document.createElement('small'); sm.textContent = 'งบโดยประมาณจากบอร์ดนี้';
      var b = document.createElement('b'); b.textContent = bb.v;
      var pp = document.createElement('p'); pp.textContent = bb.n + (bb.note ? ' · ' + bb.note : '');
      el.appendChild(sm); el.appendChild(b); el.appendChild(pp);
    }
    function render(list) {
      renderSum(list);
      listEl.innerHTML = '';
      if (!list.length) {
        var e0 = document.createElement('li');
        e0.className = 'hub-board__empty';
        e0.textContent = 'ยังไม่มีอะไรในบอร์ด กด ♡ ที่สไตล์หรือไอเดียที่ชอบ';
        listEl.appendChild(e0);
        return;
      }
      list.forEach(function (it) {
        var li = document.createElement('li');
        var th;
        var fp = /^(\d+(?:\.\d+)?)x(\d+(?:\.\d+)?)$/.exec(it.fp || '');
        if (fp) {
          th = document.createElement('span');
          th.className = 'hub-board__fp';
          var r = document.createElement('i');
          var fw = Number(fp[1]), fd = Number(fp[2]), m = Math.max(fw, fd);
          r.style.width = Math.max(6, fw / m * 36) + 'px';
          r.style.height = Math.max(6, fd / m * 36) + 'px';
          th.appendChild(r);
        } else if (it.img) {
          th = document.createElement('img');
          th.src = it.img;
          th.alt = '';
          th.loading = 'lazy';
        } else {
          th = document.createElement('span');
          th.className = 'hub-board__pal';
          (it.pal || '').split(',').forEach(function (c) {
            c = c.trim();
            if (!/^#[0-9a-f]{3,8}$/i.test(c)) return;
            var i = document.createElement('i');
            i.style.background = c;
            th.appendChild(i);
          });
        }
        var a = document.createElement('a');
        a.href = '#' + kindOf(it).pre + it.h;
        a.dataset.boardGo = it.k;
        var sm = document.createElement('small');
        sm.textContent = kindOf(it).th;
        a.appendChild(sm);
        a.appendChild(document.createTextNode(it.name));
        var rm = document.createElement('button');
        rm.type = 'button';
        rm.dataset.boardRm = it.k + ':' + it.h;
        rm.setAttribute('aria-label', 'เอาออกจากบอร์ด');
        rm.textContent = '×';
        li.appendChild(th);
        li.appendChild(a);
        li.appendChild(rm);
        listEl.appendChild(li);
      });
    }
    function toggle(btn) {
      var list = readBoard();
      var k = keyOf(btn);
      var idx = -1;
      list.forEach(function (it, i) { if (it.k + ':' + it.h === k) idx = i; });
      var added = idx < 0;
      if (added) list.push({ k: btn.dataset.kind || 'idea', h: btn.dataset.save, name: btn.dataset.name || btn.dataset.save, img: btn.dataset.img || '', pal: btn.dataset.pal || '', fp: btn.dataset.fp || '', t: btn.dataset.tier || '', a: btn.dataset.area || '' });
      else list.splice(idx, 1);
      writeBoard(list.slice(-40));
      sync(added);
    }
    function closeBoard() { if (dlg.open) dlg.close(); }

    if (fab) fab.addEventListener('click', function () {
      render(readBoard());
      if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
      lock(true);
      var x = $('[data-board-close]', dlg);
      if (x) x.focus();
    });
    dlg.addEventListener('close', function () { lock(false); if (copyBtn) copyBtn.textContent = copyLbl; });
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || e.target.closest('[data-board-close]')) { closeBoard(); return; }
      var rm = e.target.closest('[data-board-rm]');
      if (rm) {
        var k = rm.dataset.boardRm;
        writeBoard(readBoard().filter(function (it) { return it.k + ':' + it.h !== k; }));
        sync(false);
        return;
      }
      var go = e.target.closest('[data-board-go]');
      if (go) {
        closeBoard();
        if (go.dataset.boardGo === 'style') {
          e.preventDefault();
          jumpToStyle(go.getAttribute('href').slice(1));
        } else if (go.dataset.boardGo === 'layout') {
          if (jumpToLayout(go.getAttribute('href').slice(8))) e.preventDefault();
        }
        return;
      }
      if (e.target.closest('[data-board-send]')) {
        e.preventDefault();
        var list = readBoard();
        closeBoard();
        var ta = document.getElementById('ic-cf-body') || $('textarea[name="contact[body]"]');
        var target = ta ? (ta.closest('section') || ta) : document.getElementById('contact');
        if (ta && list.length) {
          var msg = boardText(list);
          var cur = ta.value.trim();
          ta.value = cur && cur.indexOf('สไตล์และไอเดียที่ชอบ') !== 0 ? cur + '\n\n' + msg : msg;
          ta.dispatchEvent(new Event('input', { bubbles: true }));
        }
        scrollToEl(target, 80);
        if (ta) setTimeout(function () { try { ta.focus({ preventScroll: true }); } catch (err) {} }, reduce ? 0 : 600);
        return;
      }
      if (e.target.closest('[data-board-copy]')) {
        var text = boardText(readBoard());
        var done = function () { copyBtn.textContent = copyBtn.dataset.done || 'คัดลอกแล้ว'; setTimeout(function () { copyBtn.textContent = copyLbl; }, 2200); };
        var fallback = function () {
          var t = document.createElement('textarea');
          t.value = text;
          t.setAttribute('readonly', '');
          t.style.position = 'fixed';
          t.style.opacity = '0';
          dlg.appendChild(t);
          t.select();
          try { document.execCommand('copy'); } catch (err) {}
          dlg.removeChild(t);
          done();
        };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(done, fallback);
        else fallback();
      }
    });
    boardApi = { sync: sync, toggle: toggle };
    sync(false);
  }
  document.addEventListener('click', function (e) {
    if (!boardApi) return;
    var s = e.target.closest('[data-save]');
    if (s) { e.preventDefault(); boardApi.toggle(s); return; }
    var p = e.target.closest('[data-save-proxy]');
    if (p) {
      var src = $('[data-save="' + p.dataset.saveProxy.replace(/"/g, '') + '"]:not([data-kind="style"])');
      if (src) boardApi.toggle(src);
    }
  });
  document.addEventListener('ic:board-sync', function () { if (boardApi) boardApi.sync(false); });
  window.addEventListener('storage', function (e) { if (e.key === BOARD_KEY && boardApi) boardApi.sync(false); });

  function boot(scope) {
    $$('[data-hub]', scope).forEach(initHub);
    $$('[data-hub-feat]', scope).forEach(initFeat);
    $$('[data-cmp]', scope).forEach(initCompare);
    $$('[data-atlas]', scope).forEach(initAtlas);
    initBoard();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
